export default __webpack_public_path__ + "static/media/14.e58f1c4f.jpg";